import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "../components/ui";
import { useAuth } from "../lib/auth-context";
import { groupLabels, modules } from "../lib/modules";
import styles from "./dashboard.module.css";

export function DashboardPage() {
  const { user, can } = useAuth();
  const visible = modules.filter((item) => can(item.id));
  return (
    <main className={styles.page}>
      <PageHeader
        title={`Добрый день, ${user?.display_name || user?.username}`}
        description="Основные сервисы и рабочие разделы."
      />
      {(["ai", "content", "operations", "system"] as const).map((group) => {
        const items = visible.filter((item) => item.group === group);
        if (!items.length) return null;
        return (
          <section className={styles.section} key={group}>
            <div className={styles.sectionHeader}>
              <h2>{groupLabels[group]}</h2>
              <span>{items.length}</span>
            </div>
            <div className={styles.grid}>
              {items.map((item) => {
                const Icon = item.icon;
                const content = (
                  <>
                    <span className={styles.icon}>
                      <Icon size={18} />
                    </span>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                    <ArrowUpRight className={styles.arrow} size={16} />
                  </>
                );
                return item.href.startsWith("http") ? (
                  <a
                    className={styles.card}
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    key={item.id}
                  >
                    {content}
                  </a>
                ) : (
                  <Link className={styles.card} to={item.href} key={item.id}>
                    {content}
                  </Link>
                );
              })}
            </div>
          </section>
        );
      })}
    </main>
  );
}
